import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import firebase from 'firebase/app';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './index.css';



  // Your web app's Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyByoMCs8ewA4qBwu-K-vXVwpWfNaGYiWVQ",
    authDomain: "good-team-442.firebaseapp.com",
    projectId: "good-team-442",
    storageBucket: "good-team-442.appspot.com",
    messagingSenderId: "171639726534",
    appId: "1:171639726534:web:bec7ded19492532a3fd2c7"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

